import tippy from "tippy.js"

// 350 is the default max-width used by tippy.js
export default function (
  el,
  {
    maxWidth = 350,
    triggerElement = el.querySelector(".trigger"),
    tooltipElement = el.querySelector(".tooltip"),
    arrow = true,
    placement = "top",
    ...rest
  } = {},
) {
  if (!triggerElement || !tooltipElement || !tooltipElement.children[0]) {
    return null
  }

  return tippy(triggerElement, {
    arrow: arrow,
    content: tooltipElement.children[0].cloneNode(true),
    interactive: true,
    theme: "dark",
    maxWidth: maxWidth,
    placement: placement,
    ...rest,
  })
}
